import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import module from "pages/css/moduleStyle.module.css";
import styles from "pages/css/busOp.module.css";
import { useTranslation } from 'react-i18next';

const TrafficTotalContext = createContext(null);

export function SwItsBisStationDataProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/busoprt/GetBusPssngrStation");
            if (response.status === 200) {
                const data = response.data;
                setCurrentData({
                    updateTime: data.updateTime,
                    ride: data.ride,
                    lndi: data.lndi
                });

            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}

// 승하차 인원 상위 정류소 현황
export function SwItsBisStationDataTotalInfo() {
    const currentData = useContext(TrafficTotalContext);
      const { t, i18n } = useTranslation(); 
    if (!currentData) return null;

    const { ride, lndi } = currentData;
    const truncateText = (text, maxLength = 15) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    return (
        <>
            <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-12)'}}>{t('Top10BusStopsByRidership')}</h2>
            </div>
            <div className={`${module.gap20} boxCont flx j_spc_btw`}>
                {/* 승차 */}
                <div className={`${styles.state} ${module.gap20} flx flx_col`}>
                    <div>승차</div>
                    <ul className={`${module.gap20} flx flx_col cst_scroll`}>
                        {ride.slice(0, 10).map((item) => (
                            <li className="innerBg flx j_spc_btw a_center">
                                <span title={item.stationNm}>
                                    {truncateText(item.stationNm)}
                                </span>
                                <span>{item.rideCnt.toLocaleString()}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* 하차 */}
                <div className={`${styles.state} ${module.gap20} flx flx_col `}>
                    <div>하차</div>
                    <ul className={`${module.gap20} flx flx_col cst_scroll`}>
                        {lndi.slice(0, 10).map((item) => (
                            <li className="innerBg flx j_spc_btw a_center">
                                <span title={item.stationNm}>
                                    {truncateText(item.stationNm)}
                                </span>
                                <span style={{ color: '#5364FF' }}>{item.lndiCnt.toLocaleString()}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}






